import { makeAutoObservable } from "mobx";

import { ResourceResponseApi } from "../../../../DTO/ServerResponseType/Resource/Resource";
import {
  AllModuleResourceTypes,
  getModuleResourceTypeString,
  ModuleResourceTypeEnum,
} from "../../../../Enums/ModuleResourceTypeEnum";
import {
  ModuleResourceResponseApi,
  ModuleResourceWithOrderResponseApi,
} from "../../../../DTO/ServerResponseType/Module/ModuleResource";
import { TaskResponseApi } from "../../../../DTO/ServerResponseType/Task/Task";

interface ModuleResourceRowApi extends ModuleResourceWithOrderResponseApi {
  name: string;
  cost: number;
  typeId: ModuleResourceTypeEnum;
}

export class ModuleResourceRowDTO implements ModuleResourceRowApi {
  name: string;
  cost: number;
  typeId: number;
  moduleResourceId: string;
  resourceId?: string;
  taskId?: string;
  order: number;
  required: boolean;

  constructor() {
    this.name = "";
    this.cost = 0;
    this.typeId = -1;
    this.moduleResourceId = "";
    this.resourceId = undefined;
    this.taskId = undefined;
    this.order = 1;
    this.required = false;
    makeAutoObservable(this);
  }

  onChangeRequired = (required: boolean) => {
    this.required = required;
  };

  onChangeOrder = (order: number) => {
    this.order = order;
  };

  onChangeType = (type: number) => {
    this.typeId = type;
  };

  copy = () => {
    let copy = new ModuleResourceRowDTO();
    copy.name = this.name;
    copy.cost = this.cost;
    copy.typeId = this.typeId;
    copy.moduleResourceId = this.moduleResourceId;
    copy.resourceId = this.resourceId;
    copy.taskId = this.taskId;
    copy.order = this.order;
    copy.required = this.required;
    return copy;
  };

  clear = () => {
    this.name = "";
    this.cost = 0;
    this.typeId = -1;
    this.moduleResourceId = "";
    this.resourceId = undefined;
    this.taskId = undefined;
    this.order = 1;
    this.required = false;
  };

  onChangeId = (id: string) => {
    if (
      this.typeId === ModuleResourceTypeEnum.Task ||
      this.typeId === ModuleResourceTypeEnum.MiniGame
    )
      this.taskId = id;
    else this.resourceId = id;
  };

  setFromModuleResourceResponse(moduleResourceData: ModuleResourceResponseApi) {
    this.moduleResourceId = moduleResourceData.moduleResourceId;
    this.order = moduleResourceData.order ?? 1;
    this.required = moduleResourceData.required;

    if (moduleResourceData.task) {
      this.setFromTaskResponse(moduleResourceData.task);
    } else if (moduleResourceData.resource) {
      this.setFromResourceResponse(moduleResourceData.resource);
    }
  }

  setFromResourceResponse(resource: ResourceResponseApi) {
    this.typeId = resource.resourceTypeId;
    this.name = resource.resourceName;
    this.cost = resource.resourceCost;
    this.resourceId = resource.resourceId;
  }

  setFromTaskResponse(task: TaskResponseApi) {
    this.typeId = task.taskContent.isMiniGame
      ? ModuleResourceTypeEnum.MiniGame
      : ModuleResourceTypeEnum.Task;
    this.name = task.taskPublicName;
    this.cost = task.taskCost;
    this.taskId = task.taskId;
  }

  get resourceTypeName(): string {
    return AllModuleResourceTypes.includes(this.typeId)
      ? getModuleResourceTypeString(this.typeId)
      : "";
  }
}
